export default RAILS_ASSET_URL("/before-after-soft-top-after.webp")
